import { combineReducers } from "redux";
import {
    authReducer,
    creationReducer,
    heatmapReducer,
    userReducer,
    notificationReducer,
    chatReducer,
    orderReducer,
    navbarReducer,
    paymentReducer,
    accountReducer,
    navigationReducer,
    uploadReducer,
    shippingAddressReducer,
} from "./modules/Reducers";
import newsReducer from "./modules/Reducers/newsReducer";
import earningReducer from "./modules/Reducers/earningReducer";
import shippingMethodsReducer from "./modules/Reducers/shippingMethodsReducer";
// import cookieConsentReducer from "./modules/Reducers/cookieConsentSlice";

const reducer = combineReducers({
    auth: authReducer,
    user: userReducer,
    creation: creationReducer,
    news: newsReducer,
    heatmap: heatmapReducer,
    chat: chatReducer,
    orders: orderReducer,
    navbar: navbarReducer,
    payments: paymentReducer,
    account: accountReducer,
    notifications: notificationReducer,
    navigation: navigationReducer,
    earnings:earningReducer,
    uploadState:uploadReducer,
    shippingAddress: shippingAddressReducer,
    shippingMethods: shippingMethodsReducer
    // cookieConsent: cookieConsentReducer
});

export default reducer;
